import { useEffect, useRef } from 'react';

const CookieLayer = ({ setShowCookie }) => {
    const ref = useRef();

    const acceptCookieNote = () => {
        window.localStorage.setItem('cookieAccepted', 'true');
        setShowCookie(false);
    };

    useEffect(() => {
        setTimeout(() => {
            if (!ref.current) {
                return;
            }

            ref.current.querySelector('sbk-button')?.click();
        }, 100);
    }, [ref.current]);

    return (
        <sbk-modal ref={ref} heading="Ihre Website-Einstellungen" hideclosebutton>
            <sbk-button slot="triggerElement" class="hidden">Open</sbk-button>
            <div>
                <p>
                    Wir verwenden erforderliche Cookies, die für den Betrieb der Webseite notwendig sind, um
                    Ihnen ein optimales Webseiten-Erlebnis zu bieten.
                </p>
            </div>
            <div slot="footer">
                <sbk-button onClick={acceptCookieNote} size="small">Ok</sbk-button>
            </div>
        </sbk-modal>
    );
};

export default CookieLayer;
